// Oddělené geometrie kolekce LINEA; původní URL zachovány.
export const PRODUCT_MENU_GROUPS = [
  { title: 'MRAK a STÉBLO', links: [
    { label: 'MLŽNÝ MRAK 1413', path: '/produkt/mlzny-mrak-1413' },
    { label: 'MLŽNÝ MRAK 1414', path: '/produkt/mlzny-mrak-1414' },
    { label: 'MLŽNÝ MRAK 1480', path: '/produkt/mlzny-mrak-1480' },
    { label: 'MLŽNÝ MRAK 2424', path: '/produkt/mlzny-mrak-2424' },
    { label: 'STÉBLO', path: '/produkt/mlzitko-steblo' },
    { label: 'AURA GARDEN', path: '/produkt/aura-mlzitko' },
  ] },
  { title: 'LINEA – sloupová kolekce', links: [
    { label: 'LINEA – rovný sloup', path: '/produkt/linea-mlzitko' },
    { label: 'LINEA CE – zakřivený sloup', path: '/produkt/Linea-ce' },
    { label: 'LINEA CE GATE – mlžná brána', path: '/produkt/linea-CE-gate' },
    { label: 'LINEA AVENUE – sestava', path: '/produkt/linea-avenue' },
  ] },
  { title: 'Brány a mlhoviště', links: [
    { label: 'BRÁNA GATE', path: '/produkt/mlzna-brana-gate' },
    { label: '2-STÉBLA', path: '/produkt/mlzitko-2-stebla' },
    { label: 'KRUH', path: '/produkt/mlzitko-kruh' },
    { label: 'Všechny mlžné brány', path: '/mlzne-brany' },
    { label: 'Mlžiště a mlhoviště', path: '/mlhoviste' },
  ] },
  { title: 'Další modely a doplňky', links: [
    { label: 'BENDY', path: '/produkt/mlzitko-bendy' },
    { label: 'Ostrev', path: '/produkt/ostrev-city' },
    { label: 'Y-ARMIST', path: '/produkt/y-armist-tr60' },
    { label: 'TEEPEE', path: '/produkt/teepee' },
    { label: 'MLŽNÁ TRYSKA', path: '/produkt/mlzici-tryska' },
    { label: 'Autorské a zakázkové tvary', path: '/zakazkova-mlzitka' },
  ] },
];